import * as React from 'react'
import Svg, { Path } from 'react-native-svg'
export const NecropsyIcon = () => (
  <Svg width={40} height={41} viewBox='0 0 40 41' fill='none'>
    <Path
      d='M18.75 12.631C14.7883 13.5849 11.3945 16.7177 9.35156 18.3677C8.76217 17.8216 8.14104 17.3108 7.49141 16.838C4.65078 14.763 1.25 14.506 1.25 14.506C1.25 14.506 2.13828 18.5318 4.48125 20.7427C2.13828 22.9544 1.25 26.9802 1.25 26.9802C1.25 26.9802 4.65078 26.7232 7.49141 24.6482C8.13555 24.1794 8.75146 23.6731 9.33594 23.1318C11.375 24.7833 14.7844 27.924 18.75 28.881L17.5 33.256C20.5805 32.7349 23.6609 30.4818 24.9 29.4865C35 29.0372 38.75 22.5529 38.75 20.756C38.75 19.0372 35 12.4747 24.9305 12.0271C23.7125 11.0513 20.6062 8.78098 17.5 8.25598L18.75 12.631Z'
      stroke='#859CAD'
      strokeWidth={2.4695}
      strokeLinejoin='round'
    />
    <Path
      d='M32.5 20.7552C33.1904 20.7552 33.75 20.1955 33.75 19.5052C33.75 18.8148 33.1904 18.2552 32.5 18.2552C31.8096 18.2552 31.25 18.8148 31.25 19.5052C31.25 20.1955 31.8096 20.7552 32.5 20.7552Z'
      fill='#859CAD'
    />
    <Path
      d='M29.5602 28.5685C28.1828 26.1952 27.4573 23.5 27.4573 20.756C27.4573 18.012 28.1828 15.3167 29.5602 12.9435'
      stroke='#859CAD'
      strokeWidth={2.4695}
      strokeMiterlimit={20}
      strokeLinecap='round'
    />
  </Svg>
)
